import { useEffect, useState } from 'react';
import FlexibleContentTile from '../Shared/Tiles/FlexibleContentTile';
import { Spinner } from './Spinner';
interface IRichText {
  leftText: string;
  rightText: string;
}
export default function Underwriting() {
  const [richText, setRichText] = useState<IRichText>({
    leftText: '<div>No insights right now.</div>',
    rightText: '<div>No insights right now.</div>',
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const getRichText = async (type: string) => {
      let richTextResult: IRichText;
      fetch(`api/sitecore/PageContentAsync/GetRecentActivitiesTabRichText`, {
        method: 'POST',
        body: new URLSearchParams({ type: type }),
      })
        .then((res) => res.json())
        .then((res) => {
          richTextResult = res as IRichText;
          setRichText(richTextResult);
        })
        .catch(() => {
          setRichText({
            leftText: '<div>No insights right now.</div>',
            rightText: '<div>No insights right now.</div>',
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    getRichText('underwriting');
  }, []);

  return isLoading ? (
    <Spinner />
  ) : (
    <FlexibleContentTile
      data-cs-mask // IMPORTANT: DO NOT REMOVE data-cs-mask attribute, this ensures the PII data is masked correctly for session replay
      isContentTile={true}
      children={[
        <div dangerouslySetInnerHTML={{ __html: richText.leftText }}></div>,
        <div dangerouslySetInnerHTML={{ __html: richText.rightText }}></div>,
      ]}
    />
  );
}
